export const TIMESTART_CHANGE = 'TIMESTART_CHANGE';
export const TIMEEND_CHANGE = 'TIMEEND_CHANGE';
export const PEOPLE_CHANGE = 'PEOPLE_CHANGE';
export const ORGANIZATIONS_CHANGE = 'ORGANIZATIONS_CHANGE';
export const COLLECTION_CHANGE = 'COLLECTION_CHANGE';
export const TYPE_CHANGE = 'TYPE_CHANGE';
export const SUBJECTS_CHANGE = 'SUBJECTS_CHANGE';
export const SEARCHTERM_CHANGE = 'SEARCHTERM_CHANGE';